module.exports = __webpack_public_path__ + "h5/img/logo2.0ed56fc9.png";